export function isEmpty(obj) {
  return Object.keys(obj).length === 0
}

export const isArray = a => Array.isArray(a)

export const und = a => typeof a === 'undefined'

export function isNode(o) {
  return typeof Node === 'object'
    ? o instanceof Node
    : o && typeof o === 'object' && typeof o.nodeType === 'number' && typeof o.nodeName === 'string'
}

export function isElement(o) {
  return typeof HTMLElement === 'object'
    ? o instanceof HTMLElement //DOM2
    : o && typeof o === 'object' && o !== null && o.nodeType === 1 && typeof o.nodeName === 'string'
}
